import { HardDrive } from "lucide-react";

/**
 * iter107 — Compact hard-drive / backup storage pill.
 *
 * Renders a single line like "💾 Drives: 58 | 59 | 60 | Drone 64" using
 * whichever of the 4 fields the studio has filled. Absent fields are
 * silently skipped so undersized shoots don't render "— | — | —".
 *
 * Reused across:
 *   • Bookings table row (under the client name)
 *   • Post-Production matrix row
 *   • Shoot Crew Management card header
 */
export default function BackupDriveBadge({ item, testid, size = "sm", className = "" }) {
  if (!item) return null;
  const drives = [
    item.backup_drive_1,
    item.backup_drive_2,
    item.backup_drive_3,
    item.backup_drive_4_drone,
  ]
    .map((d) => (d == null ? "" : String(d).trim()))
    .filter(Boolean);
  if (drives.length === 0) return null;
  const text = drives.join(" | ");
  const iconCls = size === "xs" ? "w-3 h-3" : "w-3.5 h-3.5";
  const wrapCls =
    size === "xs"
      ? "text-[10px] px-1.5 py-0.5"
      : "text-[11px] px-2 py-0.5";
  return (
    <span
      className={`inline-flex items-center gap-1 rounded-full border border-indigo-200 bg-indigo-50 text-indigo-800 font-mono ${wrapCls} ${className}`}
      title={`Storage locations · ${text}`}
      data-testid={testid || "backup-drive-badge"}
    >
      <HardDrive className={`${iconCls} shrink-0`} strokeWidth={1.8} />
      {text}
    </span>
  );
}
